import { useTranslation } from 'react-i18next';

import { LocalesEnum } from '@/constants/locales';
import { getLocaleUrl } from '@/utils/helpers/locales';

export const useLanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language;

  const handleLanguageChange = (newLocale: LocalesEnum) => {
    const { protocol, host, pathname, search } = window.location;
    const newUrl = getLocaleUrl({
      protocol,
      host,
      pathname,
      search,
      newLocale
    });

    // Use window.location.href for cross-subdomain navigation
    // router.push() cannot be used because it attempts RSC fetch across origins
    window.location.href = newUrl;
  };

  return { currentLanguage, handleLanguageChange };
};
